import {CardInput} from "../../components";
import {CardDeck} from "react-bootstrap";
import React, { useEffect } from "react";
import {useTranslation} from "react-i18next";
import { setDataType } from "../../../redux/dataProductSlice";
import { useDispatch } from "react-redux";

export default function DataTypeInput(props) {
  const { t } = useTranslation();
  const { onChange, value, disabled} = props;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setDataType(value))
  }, [value])

  return (
    <CardDeck>
      { ['locations', 'traces', 'visits', 'geovisits', 'snapped_traces', 'wifi_events', 'beacons'].map(data_type => (
        <CardInput
          icon={data_type.slice(0, -1)}
          text={t(data_type)}
          value={value === data_type}
          onChange={() => onChange(data_type)}
          disabled={disabled}
          key={data_type}
        />
      ))
      }
    </CardDeck>
  )
}
